"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hookToFAC = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
const hookToFAC = hook => {
  const NewComponent = props => {
    const hookValues = hook(props);
    const {
      children
    } = props;
    return (0, _react2.jsx)(_react.default.Fragment, null, children(hookValues));
  };
  NewComponent.displayName = "hookToFAC(".concat(hook.name, ")");
  return NewComponent;
};
exports.hookToFAC = hookToFAC;